import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "@application/config";
import { Observable } from "rxjs";
import {
  CloseProfileSubscriptionPayload,
  ProfileSubscriptionResponse,
  ProfileSubscriptionListItem,
  RenewProfileSubscriptionPayload,
  AddPauseProfileSubscriptionPayload,
  UpdatePauseProfileSubscriptionPayload,
  DeletePauseProfileSubscriptionPayload,
  SwitchProfileSubscriptionPayload,
  TransferProfileSubscriptionPayload,
} from "../entities/profile-subscription.model";

@Injectable({ providedIn: "root" })
export class ProfileSubscriptionService {
  private readonly http = inject(HttpClient);
  private readonly url = inject(APP_CONFIG).apiUrl;
  private readonly apiUrl = inject(APP_CONFIG).apiUrl.subscription_service;

  public getSubscriptionsByPerson(
    personId: string,
    filter?: number
  ): Observable<ProfileSubscriptionListItem[]> {
    let params = new HttpParams().set("personId", personId);

    if (filter !== undefined && filter !== null) {
      params = params.set("filter", String(filter));
    }

    return this.http.get<ProfileSubscriptionListItem[]>(
      `${this.apiUrl}/Subscription/GetSubscriptionsByPerson`,
      { withCredentials: true, params }
    );
  }

  public deleteSubscriptionById(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Subscription?id=${id}`, { withCredentials: true });
  }

  public deleteSubscriptionRenewals(subscriptionId: string): Observable<void> {
    const params = new HttpParams().set("subscriptionId", subscriptionId);

    return this.http.delete<void>(
      `${this.apiUrl}/Subscription/DeleteLastRenewalsWithoutReceivements`,
      { params, withCredentials: true }
    );
  }

  public renewSubscription(payload: RenewProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.post<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/Renew`,
      payload,
      { withCredentials: true }
    );
  }

  public closeSubscription(payload: CloseProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.post<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/Close`,
      payload,
      { withCredentials: true }
    );
  }

  public getSubscriptionById(id: string): Observable<ProfileSubscriptionResponse> {
    return this.http.get<ProfileSubscriptionResponse>(`${this.apiUrl}/Subscription`, {
      params: { id },
      withCredentials: true,
    });
  }

  public addSubscriptionPause(payload: AddPauseProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.post<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/AddPause`,
      payload,
      { withCredentials: true }
    );
  }

  public updateSubscriptionPause(payload: UpdatePauseProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.put<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/UpdatePause`,
      payload,
      { withCredentials: true }
    );
  }

  public deleteSubscriptionPause(payload: DeletePauseProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.delete<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/DeletePause`,
      { body: payload, withCredentials: true }
    );
  }

  public switchSubscription(payload: SwitchProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.post<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/Switch`,
      payload,
      { withCredentials: true }
    );
  }

  public transferSubscription(payload: TransferProfileSubscriptionPayload): Observable<ProfileSubscriptionResponse> {
    return this.http.post<ProfileSubscriptionResponse>(
      `${this.apiUrl}/Subscription/Transfer`,
      payload,
      { withCredentials: true }
    );
  }
}
